import { Component, QueryList, ViewChildren } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Select, Platform } from 'ionic-angular';
import { EstudoCientificoModel, Estudo } from './estudos-cientificos.modelview';
import { EstudosCientificosProvider } from './estudos-cientificos.provider';
import { InAppBrowser } from '@ionic-native/in-app-browser';

/**
 * Generated class for the EstudosCientificosPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-estudos-cientificos',
  templateUrl: 'estudos-cientificos.html',
})
export class EstudosCientificosPage {
  @ViewChildren(Select) ionSelects: QueryList<Select>;

  isBrowser: boolean = false;
  model: EstudoCientificoModel

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    private inAppBrowser: InAppBrowser,
    public platform: Platform,
    public provider: EstudosCientificosProvider) {
    this.model = new EstudoCientificoModel()
    this.isBrowser = this.navParams.get("isBrowser")
  }

  ionViewDidLoad() {
    this.solicitarListas()
  }

  solicitarListas(especialitie?) {
    this.model.estudos = []

    let loading = this.loadingCtrl.create({
      content: 'Loading'
    });
    loading.present()

    this.provider.getEstudosCientificos(especialitie).subscribe(modelProducts => {
      this.model = modelProducts;
      try {
        loading.dismiss()
      } catch (e) { }
    }, err => {
      try {
        loading.dismiss()
      } catch (e) { }
    })

  }

  abrirEstudo(estudo: Estudo) {

    if (estudo.ja_visualizou) {
      this.abrirDocumento(estudo)
      return;
    }

    let loading = this.loadingCtrl.create({
      content: 'Abrindo'
    });
    loading.present()

    this.provider.informVizualization(estudo.id).subscribe(data => {
      estudo.ja_visualizou = true
      this.abrirDocumento(estudo)
      loading.dismiss()
    }, err => {
      loading.dismiss()
    })
  }

  abrirDocumento(estudo: Estudo) {
    if (this.platform.is('core') || this.platform.is('mobileweb')) {
      window.open(estudo.url_documento == "" || estudo.url_documento == undefined ? estudo.upload_documento : estudo.url_documento, '_system');
    } else {
      this.inAppBrowser.create(estudo.url_documento == "" || estudo.url_documento == undefined ? estudo.upload_documento : estudo.url_documento, "_system", 'location=yes')
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/estudos-cientificos/estudos-cientificos.ts